<form [formGroup]="agreementForm">
    <app-form-section formGroupName="details">
        <app-form-row>
            <app-form-group class="report-container">
                <div class="box">
                    <app-agreement-periods
                        [periodForm]="periodForm"
                        [agreementForm]="agreementForm"
                        [showPotentialValidationMessages]="true"
                    ></app-agreement-periods>
                </div>
                <div class="box" *ngIf="showReminder()">
                    <app-agreement-reminder
                        [reminderForm]="reminderForm"
                        [periodForm]="periodForm"
                        [agreementName]="agreementForm.controls.details.controls.name.value"
                        [showPotentialValidationMessages]="true"
                        [isCreateMode]="true"
                    ></app-agreement-reminder>
                </div>
            </app-form-group>
            <app-form-group class="report-container">
                <div class="box stretch">
                    <app-pdf-viewer
                        #pdfviewer
                        [id]="'file2'"
                        [file]="fileForm"
                        (fileDialogStateChange)="onFileDialogStateChange($event)"
                    ></app-pdf-viewer>
                </div>
            </app-form-group>
        </app-form-row>
    </app-form-section>
</form>
